import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivateEntranceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivateEntranceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.3004 1.95349C20.2049 1.95626 20.0815 1.99569 20.0448 2.00987L20.041 2.01125C19.9352 2.05518 19.829 2.16967 19.7895 2.2807C19.7774 2.31356 19.7439 2.40314 19.7335 3.84826H16.863C14.0073 3.84826 13.7476 3.86106 13.5674 3.93439C13.3079 4.04438 13.126 4.21663 12.978 4.49127L12.8725 4.68289L12.8507 21.3101L12.9773 21.5858C13.1257 21.8614 13.3076 22.0337 13.5698 22.1451C13.7261 22.2087 13.943 22.2263 15.8824 22.2263C16.1657 22.2263 16.4863 22.226 16.8488 22.2253C17.359 22.2253 19.9103 22.2229 20.0479 22.1731C20.0618 22.1693 20.0908 22.1731 20.1105 22.1817C20.343 22.2844 20.6692 22.1495 20.7836 21.906C20.8673 21.7227 20.8673 2.46229 20.7833 2.27828C20.7024 2.10222 20.472 1.95349 20.3004 1.95349ZM16.8391 4.96963C18.6204 4.96963 19.4582 4.97101 19.6917 4.99868C19.7449 6.24422 19.7449 19.8359 19.6917 21.0797C19.4585 21.1074 18.6208 21.1088 16.8391 21.1088C15.0574 21.1088 14.2197 21.1074 13.9866 21.0797C13.9333 19.8356 13.9333 6.2425 13.9866 4.99834C14.2197 4.97101 15.0574 4.96963 16.8391 4.96963Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.5974 13.6767C15.7399 13.7493 15.8665 13.7856 15.9945 13.7856C16.13 13.7856 16.2674 13.7448 16.4268 13.6635C16.7243 13.5176 16.9574 13.1526 16.9574 12.833C16.9574 12.5885 16.7682 12.2388 16.5544 12.0866C16.3542 11.9389 15.974 11.8915 15.7461 11.9407C15.4964 11.9943 15.1526 12.3678 15.1007 12.6428C15.0201 13.081 15.21 13.4771 15.5974 13.6767Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.28639 9.90995C7.40572 9.93209 7.52574 9.94316 7.64542 9.94316C8.18155 9.94316 8.70799 9.72594 9.10334 9.33059C9.58758 8.84635 9.8048 8.16702 9.68409 7.51295C9.57686 6.92494 9.24793 6.42582 8.7578 6.1083C8.27563 5.79596 7.69869 5.69946 7.13697 5.83851C6.07094 6.10242 5.38954 7.14389 5.586 8.20923C5.74684 9.09747 6.39849 9.74911 7.28639 9.90995ZM6.71083 7.57209C6.80595 7.27601 7.02386 7.0453 7.30887 6.93842C7.37355 6.91386 7.47905 6.90245 7.59319 6.90245C7.76994 6.90245 7.96744 6.92978 8.06602 6.9782C8.22755 7.06571 8.43543 7.27359 8.51325 7.42543C8.59695 7.58523 8.62255 7.93804 8.56652 8.15041C8.50668 8.37109 8.15872 8.72908 7.94703 8.78823C7.48596 8.91552 7.07228 8.76817 6.81355 8.38112C6.65755 8.14834 6.62021 7.85364 6.71083 7.57209Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.1427 10.5211C9.99146 10.436 9.17966 10.3902 7.70733 10.3835C7.68588 10.3835 5.5355 10.3752 5.38089 10.4188L5.3757 10.4205C4.99834 10.5409 4.71194 10.7809 4.52585 11.1323C4.4162 11.3326 4.41309 11.4128 4.41309 13.9984C4.41309 15.7705 4.45505 16.7329 4.53899 16.8858C4.74168 17.2691 5.08549 17.523 5.50644 17.6004L5.53965 17.6067V19.5841C5.53965 20.2347 5.54484 21.7618 5.59465 21.8912C5.6365 22.0001 5.75826 22.117 5.8845 22.1693C5.95541 22.1983 6.02908 22.2121 6.10103 22.2121C6.30718 22.2121 6.50157 22.0987 6.59392 21.9026C6.68939 21.6795 6.68696 17.0366 6.59323 16.8374C6.46525 16.5455 6.14842 16.506 5.8558 16.506C5.64308 16.506 5.62994 16.4922 5.57528 16.4351L5.50991 16.3725V11.6231L5.64342 11.49H9.62563L9.7588 11.6235L9.75949 14.6151C9.76133 15.8658 9.67083 16.4953 9.48797 16.5036L9.35342 16.5112C9.01964 16.534 8.86018 16.578 8.77025 16.6689C8.67939 16.7533 8.62866 17.6255 8.61806 19.2856C8.60388 21.7282 8.64435 21.8182 8.67375 21.8835C8.75123 22.0786 8.93662 22.2035 9.15799 22.209C9.36898 22.209 9.57409 22.0956 9.65987 21.9081C9.70207 21.8185 9.72974 21.6086 9.72974 19.5886V17.6066L9.76191 17.6008C10.1815 17.5243 10.5305 17.2625 10.7435 16.864C10.8525 16.6648 10.8566 16.5579 10.8566 13.9983C10.8566 11.4384 10.8525 11.3312 10.7446 11.1344C10.6028 10.867 10.3935 10.6543 10.1427 10.5211Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PrivateEntranceIcon;
